<generic-modal [buttonClicked]="openModal">
    <!-- <modal-titulo>Deseo recibir el código de confirmación mediante:</modal-titulo> -->
    <modal-contenido>
        <img [src]="sedeImg.url" alt="" class="img-sede" />
    </modal-contenido>
</generic-modal>
